module.exports = __webpack_public_path__ + "img/mbp.66aa12be.png";